/**
 * File: Buttons.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.5.2
 * Created: 2025-08-01
 * Last Updated: 2026-07-26
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Link } from "react-router-dom";
import { useState } from "react";

// Icons
import { FaArrowRight } from "react-icons/fa6";
import { IoChatboxEllipsesOutline } from "react-icons/io5";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ChatButton({ onClick }) {
    return (
        <>
            <button className="chat-button" onClick={onClick}>
                <IoChatboxEllipsesOutline />
            </button>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function IconButton({ icon: Icon, onClick, size = 24 }) {
    return (
        <>
            <button className="icon-button" type="button" onClick={onClick}>
                <Icon size={size} />
            </button>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function LinkButton({ text, link, onClick, isAnchor = false }) {
    const handleScroll = (e) => {
        e.preventDefault();
        const target = document.getElementById(link.replace("#", ""));
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    return (
        <Link
            to={link}
            className="link-button"
            onClick={isAnchor ? handleScroll : onClick}
        >
            {text}
            <div className="link-button__icon">
                <FaArrowRight />
            </div>
        </Link>
    );
}

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function TextButton({ text, onClick, type = "primary", className = "" }) {
    const validTypes = ["primary", "secondary", "page", "text"];

    if (!validTypes.includes(type)) {
        type = "primary";
    }

    return (
        <>
            <button className={`${type}-button ${className}`} onClick={onClick}>
                {text}
            </button>
        </>
    );
}

/**
 * ToggleButtons component renders a group of buttons that allow switching between states.
 *
 * @component
 *
 * @param {Object} props - Component properties
 * @param {Array<{id: string, text: string, state: string}>} props.buttons -
 * Array of button configurations, each with a unique id, display text, and associated state value
 * @param {(id: string, state: string) => void} props.onClick -
 * Callback fired when a button is clicked, receiving the button's id and state
 *
 * @returns {JSX.Element} An inline group of toggle buttons
 *
 * @example
 * <ToggleButtons
 *   buttons={[
 *     { id: "view-list", text: "List", state: "list" },
 *     { id: "view-grid", text: "Grid", state: "grid" },
 *   ]}
 *   onClick={(state) => setView(state)}
 * />
 */
function ToggleButtons({ buttons, onClick }) {
    const [activeButton, setActiveButton] = useState(buttons[0].id);

    const handleOnClick = (id, state) => {
        setActiveButton(id);
        onClick(state);
    };

    return (
        <>
            <div className="toggle-buttons">
                {buttons.map((button) => (
                    <button
                        key={button.id}
                        type="button"
                        onClick={() => handleOnClick(button.id, button.state)}
                        className={`toggle-buttons_button
                            ${
                                activeButton === button.id
                                    ? "toggle-buttons__button--active"
                                    : "toggle-buttons__button--deactive"
                            }`}
                    >
                        {button.text}
                    </button>
                ))}
            </div>
        </>
    );
}

export { ChatButton, IconButton, LinkButton, TextButton, ToggleButtons };
